export default __webpack_public_path__ + "static/media/alipayColor.7fb6d6f2.svg";